import { put, call } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    getQuizSuccess, getQuizFail,
    getAllQuizzesSuccess, getAllQuizzesFail,
    getQuizzesByModuleSuccess, getQuizzesByModuleFail,
    getQuizzesByTypeSuccess, getQuizzesByTypeFail,
    createQuizSuccess, createQuizFail,
    updateQuizSuccess, updateQuizFail,
    deleteQuizSuccess, deleteQuizFail,
    getQuestionsByQuizSuccess, getQuestionsByQuizFail,
    createQuestionSuccess, createQuestionFail,
    updateQuestionSuccess, updateQuestionFail,
    deleteQuestionSuccess, deleteQuestionFail,
    setQuizLoading,  startQuizAttemptSuccess, startQuizAttemptFail,
    submitQuizAttemptSuccess, submitQuizAttemptFail,
    getQuizAttemptSuccess, getQuizAttemptFail,
    getAttemptsByCollaborateurSuccess, getAttemptsByCollaborateurFail
} from "../actions/quizActions";
import {
    API_BASE_URL,
    getRequest,
    postRequest,
    putRequest,
    deleteRequest
} from "../../../api";

const getUidHeader = () => {
    const uid = sessionStorage.getItem("uid") || localStorage.getItem("uid");
    return uid ? { uid } : {};
};
const getErrorMessage = (error, fallback) =>
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback;

// ===== Quiz =====
export function* getQuizSaga(action) {
    const url = `${API_BASE_URL}/api/quizzes/${action.payload.quizId}`;
    yield put(setQuizLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getQuizSuccess(resp.data));
    } catch (error) {
        yield put(getQuizFail(getErrorMessage(error, "Erreur lors de la récupération du quiz")));
    } finally {
        yield put(setQuizLoading(false));
    }
}

export function* getAllQuizzesSaga() {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/quizzes`;
    yield put(setQuizLoading(true));
    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getAllQuizzesSuccess(resp.data));
    } catch (error) {
        yield put(getAllQuizzesFail(getErrorMessage(error, "Erreur lors de la récupération des quiz")));
    } finally {
        yield put(setQuizLoading(false));
    }
}

export function* getQuizzesByModuleSaga(action) {
    const url = `${API_BASE_URL}/api/quizzes/module/${action.payload.moduleId}`;
    yield put(setQuizLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getQuizzesByModuleSuccess(resp.data));
    } catch (error) {
        yield put(getQuizzesByModuleFail(getErrorMessage(error, "Erreur lors du filtrage par module")));
    } finally {
        yield put(setQuizLoading(false));
    }
}

export function* getQuizzesByTypeSaga(action) {
    const url = `${API_BASE_URL}/api/quizzes/type/${action.payload.typeQuiz}`;
    yield put(setQuizLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getQuizzesByTypeSuccess(resp.data));
    } catch (error) {
        yield put(getQuizzesByTypeFail(getErrorMessage(error, "Erreur lors du filtrage par type")));
    } finally {
        yield put(setQuizLoading(false));
    }
}

export function* createQuizSaga(action) {
    const url = `${API_BASE_URL}/api/quizzes`;
    const data = action.payload;
    const headers = getUidHeader();

    yield put(setQuizLoading(true));
    try {
        const resp = yield call(postRequest, { url, data,headers });
        yield put(createQuizSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            text: "Quiz créé avec succès",
            timer: 1800,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(createQuizFail(getErrorMessage(error, "Erreur lors de la création")));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: getErrorMessage(error, "Erreur lors de la création"),
            confirmButtonText: "OK"
        });
    } finally {
        yield put(setQuizLoading(false));
    }
}

export function* updateQuizSaga(action) {
    const url = `${API_BASE_URL}/api/quizzes/${action.payload.quizId}`;
    const data = action.payload.quizData;
    yield put(setQuizLoading(true));
    try {
        const resp = yield call(putRequest, { url, data });
        yield put(updateQuizSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            text: "Quiz mis à jour avec succès",
            timer: 1800,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(updateQuizFail(getErrorMessage(error, "Erreur lors de la mise à jour")));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: getErrorMessage(error, "Erreur lors de la mise à jour"),
            confirmButtonText: "OK"
        });
    } finally {
        yield put(setQuizLoading(false));
    }
}

export function* deleteQuizSaga(action) {
    const url = `${API_BASE_URL}/api/quizzes/${action.payload.quizId}`;
    yield put(setQuizLoading(true));
    try {
        yield call(deleteRequest, { url });
        yield put(deleteQuizSuccess(action.payload.quizId));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            text: "Quiz supprimé avec succès",
            timer: 1800,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(deleteQuizFail(getErrorMessage(error, "Erreur lors de la suppression")));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: getErrorMessage(error, "Erreur lors de la suppression"),
            confirmButtonText: "OK"
        });
    } finally {
        yield put(setQuizLoading(false));
    }
}

// ===== Questions =====
export function* getQuestionsByQuizSaga(action) {
    const url = `${API_BASE_URL}/api/questions/quiz/${action.payload.quizId}`;
    yield put(setQuizLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getQuestionsByQuizSuccess(resp.data));
    } catch (error) {
        yield put(getQuestionsByQuizFail(getErrorMessage(error, "Erreur lors de la récupération des questions")));
    } finally {
        yield put(setQuizLoading(false));
    }
}

export function* createQuestionSaga(action) {
    const url = `${API_BASE_URL}/api/questions`;
    const data = action.payload;
    const headers = getUidHeader();

    yield put(setQuizLoading(true));
    try {
        const resp = yield call(postRequest, { url, data ,headers});
        yield put(createQuestionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            text: "Question créée avec succès",
            timer: 1800,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(createQuestionFail(getErrorMessage(error, "Erreur lors de la création de la question")));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: getErrorMessage(error, "Erreur lors de la création de la question"),
            confirmButtonText: "OK"
        });
    } finally {
        yield put(setQuizLoading(false));
    }
}

export function* updateQuestionSaga(action) {
    const url = `${API_BASE_URL}/api/questions/${action.payload.questionId}`;
    const data = action.payload.questionData;
    yield put(setQuizLoading(true));
    try {
        const resp = yield call(putRequest, { url, data });
        yield put(updateQuestionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            text: "Question mise à jour avec succès",
            timer: 1800,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(updateQuestionFail(getErrorMessage(error, "Erreur lors de la mise à jour de la question")));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: getErrorMessage(error, "Erreur lors de la mise à jour de la question"),
            confirmButtonText: "OK"
        });
    } finally {
        yield put(setQuizLoading(false));
    }
}

export function* deleteQuestionSaga(action) {
    const url = `${API_BASE_URL}/api/questions/${action.payload.questionId}`;
    yield put(setQuizLoading(true));
    try {
        yield call(deleteRequest, { url });
        yield put(deleteQuestionSuccess(action.payload.questionId));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            text: "Question supprimée avec succès",
            timer: 1800,
            showConfirmButton: false
        });
    } catch (error) {
        yield put(deleteQuestionFail(getErrorMessage(error, "Erreur lors de la suppression de la question")));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: getErrorMessage(error, "Erreur lors de la suppression de la question"),
            confirmButtonText: "OK"
        });
    } finally {
        yield put(setQuizLoading(false));
    }
}


export function* startQuizAttemptSaga(action) {
    const url = `${API_BASE_URL}/api/quiz-attempts/start`;
    const data = action.payload;
    yield put(setQuizLoading(true));

    try {
        const resp = yield call(postRequest, { url, data });
        yield put(startQuizAttemptSuccess(resp.data));
    } catch (error) {
        const message = getErrorMessage(error, "Erreur lors du démarrage du quiz");
        yield put(startQuizAttemptFail(message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: message,
            confirmButtonText: 'OK'
        });
    } finally {
        yield put(setQuizLoading(false));
    }
}

export function* submitQuizAttemptSaga(action) {
    const url = `${API_BASE_URL}/api/quiz-attempts/submit`;
    const data = action.payload;

    try {
        const resp = yield call(postRequest, { url, data });
        yield put(submitQuizAttemptSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            text: "Quiz soumis avec succès",
            timer: 1800,
            showConfirmButton: false
        });
    } catch (error) {
        const message = getErrorMessage(error, "Erreur lors de la soumission du quiz");
        yield put(submitQuizAttemptFail(message));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            text: message,
            confirmButtonText: 'OK'
        });
    }
}

export function* getQuizAttemptSaga(action) {
    const url = `${API_BASE_URL}/api/quiz-attempts/${action.payload.tentativeId}`;
    yield put(setQuizLoading(true));

    try {
        const resp = yield call(getRequest, { url });
        yield put(getQuizAttemptSuccess(resp.data));
    } catch (error) {
        yield put(getQuizAttemptFail(getErrorMessage(error, "Erreur lors de la récupération de la tentative")));
    } finally {
        yield put(setQuizLoading(false));
    }
}

export function* getAttemptsByCollaborateurSaga(action) {
    const url = `${API_BASE_URL}/api/quiz-attempts/collaborateur/${action.payload.collaborateurId}`;
    yield put(setQuizLoading(true));

    try {
        const resp = yield call(getRequest, { url });
        yield put(getAttemptsByCollaborateurSuccess(resp.data));
    } catch (error) {
        yield put(getAttemptsByCollaborateurFail(getErrorMessage(error, "Erreur lors de la récupération de l'historique")));
    } finally {
        yield put(setQuizLoading(false));
    }
}